import React from "react";
import Field from "@/components/post-ad/Field";

/**
 * Collapsible agency-branding block — name, licence and logo. Populates a
 * branded seller card on the public ad detail page.
 */
export default function AgencySection({ form, set, uploadAgencyLogo }) {
  return (
    <details
      className="rounded-2xl bg-slate-50 border border-soft p-4"
      data-testid="post-ad-agency-section"
    >
      <summary className="cursor-pointer font-display font-bold text-slate-800 text-sm">
        Agency branding <span className="text-slate-400 font-normal">(optional)</span>
      </summary>
      <p className="mt-3 text-xs text-slate-500">
        Add your agency to display a branded seller card on your ad. Great for real-estate,
        dealership and machinery listings.
      </p>
      <div className="mt-4 grid md:grid-cols-2 gap-3">
        <Field label="Agency name">
          <input
            data-testid="post-ad-agency-name"
            value={form.agency_name}
            onChange={(e) => set({ agency_name: e.target.value.slice(0, 80) })}
            className="input"
            placeholder="e.g. Barfoot & Thompson Epsom"
            maxLength={80}
          />
        </Field>
        <Field label="Licence / REAA (optional)">
          <input
            data-testid="post-ad-agency-license"
            value={form.agency_license}
            onChange={(e) => set({ agency_license: e.target.value.slice(0, 80) })}
            className="input"
            placeholder="e.g. Licensed: REAA 2008"
            maxLength={80}
          />
        </Field>
      </div>
      <div className="mt-3">
        <Field label="Agency logo (PNG or JPG, ≤ 2 MB)">
          <div className="flex items-center gap-3">
            {form.agency_logo && (
              <img
                src={form.agency_logo}
                alt="Agency logo"
                data-testid="post-ad-agency-logo-preview"
                className="w-16 h-16 rounded-xl object-contain bg-white border border-soft p-1"
              />
            )}
            <label className="rounded-full px-4 py-2 bg-slate-100 hover:bg-slate-200 text-sm font-semibold cursor-pointer transition-colors">
              {form.agency_logo ? "Replace logo" : "Upload logo"}
              <input
                type="file"
                accept="image/png,image/jpeg,image/webp"
                className="sr-only"
                data-testid="post-ad-agency-logo-input"
                onChange={(e) => e.target.files?.[0] && uploadAgencyLogo(e.target.files[0])}
              />
            </label>
            {form.agency_logo && (
              <button
                type="button"
                onClick={() => set({ agency_logo: "" })}
                data-testid="post-ad-agency-logo-remove"
                className="text-xs font-semibold text-red-500 hover:underline"
              >
                Remove
              </button>
            )}
          </div>
        </Field>
      </div>
    </details>
  );
}
